import { Pipe, PipeTransform, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { TolgeeService } from '@core/translation/tolgee.service';
import { HashMap } from '@core/translation/translation-models';
import { Subscription } from 'rxjs';

@Pipe({
    name: 'translate',
    pure: false,
    standalone: false
})
export class TranslatePipe implements PipeTransform, OnDestroy {
    private readonly _languageChangeSub: Subscription;

    constructor(
        private tolgeeService: TolgeeService,
        private changeDetectorRef: ChangeDetectorRef,
    ) {
        this._languageChangeSub = this.tolgeeService.language$.subscribe(() => {
            this.changeDetectorRef.markForCheck();
        });
    }

    transform(key: string, params?: HashMap, fallback?: string): string {
        return this.tolgeeService.translate(key, params, fallback);
    }

    ngOnDestroy(): void {
        this._languageChangeSub.unsubscribe();
    }
}
